import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-27/task-02";

const task: Slide = {
  title: "Click on the properties that the differential microphone arrays have.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
